// test1679
(1679 && 0);
